/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ApplicationStatus {
  Draft = "Draft",
  Submitted = "Submitted",
  Sparring = "Sparring",
  Returned = "Returned",
  UnderConsideration = "UnderConsideration",
  Rejected = "Rejected",
  Approved = "Approved",
  CustomerActionNeeded = "CustomerActionNeeded",
  PayoutRequestDraft = "PayoutRequestDraft",
  PayoutRequestReturned = "PayoutRequestReturned",
  OfferExpired = "OfferExpired",
  Annulled = "Annulled",
  CaseCompleted = "CaseCompleted",
  ReturnedByMunicipality = "ReturnedByMunicipality",
  UnallocatedMunicipality = "UnallocatedMunicipality",
  UnderConsiderationMunicipality = "UnderConsiderationMunicipality",
  Withdrawn = "Withdrawn",
  PendingDecision = "PendingDecision"
}